module.exports = __webpack_public_path__ + "img/oufu_80x95x10b.prt.0213327b.jpg";